import type { Locale } from '@change-corgi/config/locales';

import __json from '../config/paypal.json';

type DataFromJson = Readonly<{
	locales: Readonly<Record<Locale, string>>;
}>;

const data: DataFromJson = __json;

export function getPaypalLocale(locale: Locale): string {
	return data.locales[locale];
}
